// Project 2 - CarSales
export const project3 = {
    id: 3,
    title: "Food macro tracker APP",
    description: "This is a sleek, black-themed mobile app designed for daily nutrition and wellness tracking. It offers a clean dashboard to monitor macronutrient intake (Protein, Carbs, Fats) against daily goals, a simple interface for logging specific meals with detailed macro breakdowns, and a Deep Insights view to analyze meal patterns, caloric balance, and associated mood/focus rituals. Its dark aesthetic emphasizes clarity and data-at-a-glance.",
    website: null, 
    images: [
        "/Project-CaloriesAPP/APP.png",
  
    ],
};

